<div
  #tournament_slider
  class="tournament-slider"
  [ngClass]="{
    'tournament-slider__video': existVideoInAnyAdvertisement
  }"
  [style.background-image]="'url(/shared/img/game_lobby_bg.webp)'"
>
  <swiper #swiper [config]="config">
    <ng-template swiperSlide>
      <div id="slide" class="slide slide-1">
        <div class="text-img">
          <img src="/shared/img/game_lobby_title.webp" alt="Game Lobby" />
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide *ngFor="let tournament of advertisements">
      <fz-banner
        [user]="currentUser$ | async"
        [timeZone]="(currentUser$ | async)?.user?.userSettings?.timezone"
        [tournament]="tournament"
        [ts]="tournament"
        [actionBarConfig]="{ showJoinButton: true, showShareButton: true }"
        (joinPress)="onJoinPress(tournament)"
        (sharePress)="onSharePress(tournament)"
      ></fz-banner>
    </ng-template>
  </swiper>
</div>
